import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Typography } from '@slope/uikit';

const TriggerElement = styled.div`
  height: 20px;
  margin: 2rem 0;
`;

const LoadingMore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export interface LoadMoreTriggerProps {
  onLoadMore: () => void;
  isLoading?: boolean;
  threshold?: number;
  loadingMessage?: string;
}

export const LoadMoreTrigger: React.FC<LoadMoreTriggerProps> = ({
  onLoadMore,
  isLoading = false,
  threshold = 0.1,
  loadingMessage = 'Cargando más clubes...',
}) => {
  const observerTarget = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!onLoadMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isLoading) {
          onLoadMore();
        }
      },
      { threshold },
    );

    const currentTarget = observerTarget.current;
    if (currentTarget) {
      observer.observe(currentTarget);
    }

    return () => {
      if (currentTarget) {
        observer.unobserve(currentTarget);
      }
    };
  }, [onLoadMore, isLoading, threshold]);

  return (
    <>
      <TriggerElement ref={observerTarget} />
      {isLoading && (
        <LoadingMore>
          <LoadingSpinner />
          <Typography fontSize="16px" ml="1rem">
            {loadingMessage}
          </Typography>
        </LoadingMore>
      )}
    </>
  );
};
